import {
  LayerProvider,
  PortalProvider,
  studioTheme,
  type ThemeColorSchemeKey,
  ThemeProvider as SanityThemeProvider,
  ToastProvider,
  usePrefersDark,
} from '@sanity/ui'
import {useState} from 'react'

import {darkThemeClass, themeClass} from '~/theme.css'

export function ThemeProvider({
  children,
  scheme = 'light',
}: {
  children: React.ReactNode
  scheme?: ThemeColorSchemeKey
}) {
  const [portalElement, setPortalElement] = useState<HTMLDivElement | null>(null)
  return (
    <SanityThemeProvider theme={studioTheme} scheme={scheme}>
      <PortalProvider element={portalElement}>
        <ToastProvider zOffset={2000}>
          <LayerProvider>{children}</LayerProvider>
        </ToastProvider>
      </PortalProvider>
      <div data-portal="" ref={setPortalElement} />
    </SanityThemeProvider>
  )
}

type UseTheme = [ThemeColorSchemeKey, string]
const lightTheme = ['light', themeClass] satisfies UseTheme
const darkTheme = ['dark', darkThemeClass] satisfies UseTheme
export function useTheme(hydratedScheme?: ThemeColorSchemeKey) {
  const systemPrefersDark = usePrefersDark()
  switch (true) {
    case hydratedScheme === 'light':
      return lightTheme
    case hydratedScheme === 'dark':
    case systemPrefersDark:
      return darkTheme
    default:
      return lightTheme
  }
}
